export default "__VITE_ASSET__Dt$N0rq6__"